import { c as _c } from "react/compiler-runtime";
import React from "react";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
interface InfoButtonProps {
  readonly loading?: boolean | undefined;
  readonly disabled?: boolean | undefined;
  readonly onClicked?: (() => void) | undefined;
  readonly children: React.ReactNode;
  readonly padding?: string | undefined;
  readonly title?: string | undefined;
  readonly variant?: "primary" | "info" | "muted" | undefined;
  readonly fullWidth?: boolean | undefined;
  readonly className?: string | undefined;
}

/**
 * Info-styled button for informational states like "coming soon"
 */
export default function InfoButton(t0) {
  const $ = _c(10);
  const {
    loading: t1,
    disabled: t2,
    onClicked,
    children,
    padding: t3,
    title,
    variant: t4,
    fullWidth: t5,
    className: t6
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const disabled = t2 === undefined ? false : t2;
  const padding = t3 === undefined ? "tw-px-2.5 tw-py-2" : t3;
  const variant = t4 === undefined ? "info" : t4;
  const fullWidth = t5 === undefined ? true : t5;
  const className = t6 === undefined ? "" : t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      primary: "tw-bg-green-600/20 tw-text-green-400 tw-border tw-border-solid tw-border-green-700 hover:tw-bg-green-600/30",
      info: "tw-bg-blue-600/20 tw-text-blue-400 tw-border tw-border-solid tw-border-blue-700 hover:tw-bg-blue-600/30",
      muted: "tw-bg-iron-800 tw-text-iron-400 tw-border tw-border-solid tw-border-iron-700 tw-cursor-not-allowed"
    };
    $[0] = t7;
  } else {
    t7 = $[0];
  }
  const variantClasses = t7;
  const widthClasses = fullWidth ? "tw-w-full" : "tw-w-auto";
  const baseClasses = `tw-flex ${widthClasses} tw-gap-x-1.5 tw-items-center tw-justify-center tw-rounded-lg ${padding} tw-text-sm tw-font-semibold tw-transition tw-duration-200 tw-ease-out`;
  const disabledClasses = disabled || loading ? "tw-opacity-50" : "";
  const t8 = disabled || loading;
  const t9 = `${baseClasses} ${variantClasses[variant]} ${disabledClasses} ${className}`;
  let t10;
  if ($[1] !== loading) {
    t10 = loading && <CircleLoader />;
    $[1] = loading;
    $[2] = t10;
  } else {
    t10 = $[2];
  }
  let t11;
  if ($[3] !== children || $[4] !== onClicked || $[5] !== t10 || $[6] !== t8 || $[7] !== t9 || $[8] !== title) {
    t11 = <button onClick={onClicked} disabled={t8} type="button" title={title} className={t9}>{t10}{children}</button>;
    $[3] = children;
    $[4] = onClicked;
    $[5] = t10;
    $[6] = t8;
    $[7] = t9;
    $[8] = title;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  return t11;
}